import React, { useState } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import GlobalTopNavBar from './GlobalTopNavBar';
import GlobalDrawer from './GlobalDrawer';

interface AuthLayoutProps {
    children: React.ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const handleDrawerToggle = () => {
        setDrawerOpen(!drawerOpen);
    };

    const handleDrawerClose = () => {
        setDrawerOpen(false);
    };

    // On desktop, the drawer should always be open (persistent)
    const isDrawerOpen = isMobile ? drawerOpen : true;

    return (
        <Box sx={{ display: 'flex', minHeight: '100vh' }}>
            {/* Persistent Sidebar on Desktop, Drawer on Mobile */}
            <GlobalDrawer 
                open={isDrawerOpen} 
                onClose={handleDrawerClose}
                variant={isMobile ? 'temporary' : 'persistent'}
                isMobile={isMobile}
            />
            
            {/* Main Content Area */}
            <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column', 
                flex: 1,
                minWidth: 0, // Prevents flex item from overflowing
            }}>
                <GlobalTopNavBar onDrawerToggle={handleDrawerToggle} isMobile={isMobile} />
                <Box sx={{ 
                    flex: 1, 
                    overflow: 'auto',
                    // Add left margin on desktop to account for persistent sidebar
                    ml: isMobile ? 0 : '280px',
                }}>
                {children}
                </Box>
            </Box>
        </Box>
    );
};

export default AuthLayout; 